import { useCallback } from "react";
import { axiosSettings } from "./axios";

export const useDeleteOrganisationFilterView = () => {
  const [state, execute, cancel] = axiosSettings<void, void, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string) => {
      return execute({
        url: `/v2/organisations/filterView/${id}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
